export const Paths = {
  home: "/",
  projects: "/projectos",
}
